export const networkStatus = parseInt(import.meta.env.VITE_NETWORK_STATUS)